import { Controller } from "@hotwired/stimulus"
import $ from "jquery"

export default class extends Controller {
    static targets = ["select", "formFrame", "submitButton"]
    static values = {
        combineUrl: String
    }

    declare selectTarget: HTMLSelectElement
    declare formFrameTarget: HTMLElement
    declare submitButtonTarget: HTMLButtonElement
    declare combineUrlValue: string

    connect() {
        this.updateSubmitButton()
        if (this.selectTarget.value) {
            this.loadCageFormFromValue(this.selectTarget.value)
        }
    }

    loadCageForm(event: Event) {
        const otherCageId = (event.target as HTMLSelectElement).value
        this.loadCageFormFromValue(otherCageId)
    }

    loadCageFormFromValue(otherCageId: string) {
        if (!otherCageId) {
            this.clearForm()
            this.updateSubmitButton()
            return
        }

        const $frame = $(this.formFrameTarget)
        const url = `${this.combineUrlValue}&other_cage_id=${otherCageId}`
        $frame.attr("src", url)
        this.updateSubmitButton()
    }

    clearForm() {
        const $frame = $(this.formFrameTarget)
        $frame.attr("src", this.combineUrlValue)
    }

    updateSubmitButton() {
        this.submitButtonTarget.disabled = !this.selectTarget.value
    }
}
